/**
 * @author wuTao
 * @description 单店报告详情
 * @Date 2023/05/31
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config'

import {framework_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;

class StoreReportInfoList extends WizContainer {

  componentName = 'StoreReportInfoList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig({
        _this: this,
      }),
      apiDataFormat: {},
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(StoreReportInfoList);
